import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-530109da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "searchMain bg-fff m-t-8" }
const _hoisted_3 = { class: "condition" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rect"
}, null, -1))
const _hoisted_5 = { class: "wrap-title" }
const _hoisted_6 = { class: "d-f" }
const _hoisted_7 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "付款轮次", -1))
const _hoisted_9 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "经销商SWT编码", -1))
const _hoisted_11 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "经销商编码", -1))
const _hoisted_13 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "经销商名称", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-f flex-w-auto flex-d-c m-l-16" }, null, -1))
const _hoisted_16 = { class: "main bg-fff m-t-8 flex-w-auto d-f flex-d-c" }
const _hoisted_17 = { class: "d-f justify-e" }
const _hoisted_18 = { class: "d-f" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_20 = { class: "table-wrapper flex-w-auto m-t-16" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_TableWrapper = _resolveComponent("TableWrapper")!
  const _component_upload_detail = _resolveComponent("upload-detail")!
  const _component_main_wrapper = _resolveComponent("main-wrapper")!

  return (_openBlock(), _createBlock(_component_main_wrapper, { className: "p-l-r-10" }, {
    header: _withCtx(() => [
      _createVNode(_component_Breadcrumb, {
        dataSource: [{name: _ctx.$t('payment.BreakdownDetail')}]
      }, null, 8, ["dataSource"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", null, [
              _hoisted_4,
              _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.$t('payment.BreakdownDetail')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_a_input, {
                value: _ctx.searchParams.payoutRoundCN,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParams.payoutRoundCN) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_a_input, {
                value: _ctx.searchParams.swtCode,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParams.swtCode) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_a_input, {
                value: _ctx.searchParams.dealerCode,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParams.dealerCode) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_a_input, {
                value: _ctx.searchParams.dealerNameCn,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParams.dealerNameCn) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.downloadClick
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_TableWrapper, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  class: "tab-container default-self-table-text",
                  "row-selection": _ctx.rowSelection,
                  columns: _ctx.columnsData,
                  scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight},
                  pagination: false,
                  dataSource: _ctx.tableData,
                  rowKey: "id",
                  rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
                }, {
                  download: _withCtx(({ record }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.fileRespVOList, (item, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: _normalizeClass(['download-link', item.fileFlag ? 'link cursor-p' : 'color-g']),
                        onClick: ($event: any) => (_ctx.fileClick(record, item.fileCode, item.fileFlag))
                      }, _toDisplayString(item.fileNameCN), 11, _hoisted_21))
                    }), 128)),
                    (record.vehicleDetailsFile)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(['download-link', record.vehicleDetailsFileFlag ? 'link cursor-p' : 'color-g']),
                          onClick: ($event: any) => (_ctx.paymentClaimExport(_ctx.searchParams.dealerCode, record.entity, _ctx.searchParams.payoutRound, record.vehicleDetailsFileFlag))
                        }, _toDisplayString(record.vehicleDetailsFile), 11, _hoisted_22))
                      : _createCommentVNode("", true),
                    (record.shouldDisplayDeductionFile)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(['download-link', record.vehicleDetailsFileFlag ? 'link cursor-p' : 'color-g']),
                          onClick: ($event: any) => (_ctx.demoCarDeductionExport(record.entity))
                        }, " 试驾车扣款明细 ", 10, _hoisted_23))
                      : _createCommentVNode("", true)
                  ]),
                  upload: _withCtx(({ record }) => [
                    _withDirectives(_createElementVNode("span", {
                      class: _normalizeClass(['font_family icon-shangchuan', record.status !== '已通过' && record.status !== '' ? 'link cursor-p' : 'color-g']),
                      style: {"font-size":"16px"},
                      onClick: ($event: any) => (_ctx.uploadClick(record))
                    }, null, 10, _hoisted_24), [
                      [_vShow, record.entity === 'MBCL']
                    ])
                  ]),
                  _: 1
                }, 8, ["row-selection", "columns", "scroll", "dataSource", "rowClassName"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      (_ctx.isUploadVisible)
        ? (_openBlock(), _createBlock(_component_upload_detail, {
            key: 0,
            onChangeTable: _ctx.refreshTable,
            isUploadVisible: _ctx.isUploadVisible,
            uploadTitle: "Upload BBAC Vehicle List",
            dealerDetailApproveId: _ctx.dealerDetailApproveId,
            onCloseUploadVisible: _ctx.closeUpload
          }, null, 8, ["onChangeTable", "isUploadVisible", "dealerDetailApproveId", "onCloseUploadVisible"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}